import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-development-service',
  templateUrl: './custom-development-service.component.html',
  styleUrls: ['./custom-development-service.component.scss']
})
export class CustomDevelopmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
